import urlConfig from "app/config/urlConfig";
import { AUTH } from "app/utils/constants/endPoint";

export const getFile = async (API, data, isWebview = true) => {
  let apiDef = urlConfig[API];
  let apiDefToken = urlConfig[AUTH.GENERATE_TOKEN];

  let url = apiDef.baseUrl + apiDef.endpoint;

  let token = "";

  if (!isWebview) {
    token = localStorage.getItem("token");
  } else {
    let urltoken = apiDefToken.baseUrl + apiDefToken.endpoint;

    const resToken = await fetch(`${urltoken}/${(localStorage.getItem('USER_WV') ?? 'm_connect')}`, {
      method: 'GET'
    })

    const body = await resToken.json();

    token = body.data.token;
  }

  const response = await fetch(url + '?' + new URLSearchParams(data), {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })

  const blob = await response.blob()

  return await getBase64(blob)
}

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let baseURL = "";
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onerror = reject;
    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};